//面积图
import area from './area';
//柱状图2d
import bar2d from './bar2d';
//柱状图3d
import bar3d from './bar3d';
//柱状图3d
import bargraph from './bargraph';
//环形图
import doughnut from './doughnut';
//仪表盘
import gauge from './gauge';
//折线图
import line from './line';
//饼图2d
import pie2d from './pie2d';
//饼图3d
import pie3d from './pie3d';

export default {
	1: bar2d,
	2: bar3d,
	3: line,
	4: area,
	5: bargraph,
	6: pie2d,
	7: pie3d,
	8: doughnut,
	11: gauge
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/echart/examples/index.js